var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrap"},[(_vm.$slots.head)?_c('div',{staticClass:"page-head"},[_vm._t("head")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }